let productIdWrapper = document.getElementById('relatedProducts');
if (productIdWrapper) {
    let productId = productIdWrapper.getAttribute('data-related-product-id');

    (function (productId) {
        // track Swiper initialization
        let swiperInitialized = false;
        let swiperInstance = null;

        // Add loading spinner
        const container = document.querySelector('#relatedProducts');

        // Wait for Algolia Recommend to be available with better reliability
        function waitForAlgoliaRecommend() {
            return new Promise((resolve, reject) => {
                console.log('🔍 Waiting for Algolia Recommend...');
                let attempts = 0;
                const maxAttempts = 150; // 15 seconds max (increased for defer scripts)
                
                const check = () => {
                    attempts++;
                    if (attempts > maxAttempts) {
                        console.error('❌ Timeout waiting for Algolia Recommend after', maxAttempts * 100, 'ms');
                        console.log('🔍 Final state check:', {
                            'window["@algolia/recommend"]': !!window['@algolia/recommend'],
                            'typeof': typeof window['@algolia/recommend']
                        });
                        reject(new Error('Timeout waiting for Algolia Recommend'));
                        return;
                    }
                    
                    // The CDN version exposes @algolia/recommend as a direct function
                    if (typeof window['@algolia/recommend'] === 'function') {
                        console.log('✅ Algolia Recommend found! (Function-based CDN version)');
                        resolve({ recommendClient: window['@algolia/recommend'] });
                    } else if (window['@algolia/recommend'] && window['@algolia/recommend'].recommendClient) {
                        console.log('✅ Algolia Recommend found! (Object-based version)');
                        resolve(window['@algolia/recommend']);
                    } else {
                        // Only log every 10th attempt to reduce console spam
                        if (attempts % 10 === 0) {
                            console.log(`🔍 Still waiting... (attempt ${attempts}/${maxAttempts})`);
                        }
                        setTimeout(check, 100);
                    }
                };
                
                // Start checking immediately, but also wait for DOM ready and load events
                check();
                
                // Also check after DOM is ready
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', check);
                }
                
                // And after window load (for defer scripts)
                if (document.readyState !== 'complete') {
                    window.addEventListener('load', check);
                }
            });
        }

                // Initialize with proper dependency waiting
        waitForAlgoliaRecommend().then((recommend) => {
            console.log('🚀 Initializing Algolia client for product:', productId);
            const recommendClient = recommend.recommendClient('SFLNT8GKGO', '347e9eacdf2e5920541b0e2f0a4c65d1');
            let indexName = 'shopify_products';
            let currentObjectID = productId;
        container.innerHTML = `
            <div class="loading-spinner-wrapper">
                <div class="loading-spinner">
                    <div class="spinner"></div>
                </div>
            </div>
        `;
        container.classList.remove('loaded');

        // Check Swiper is available - mitigate dependency errors
        function waitForDependencies() {
            return new Promise((resolve) => {
                const check = () => {
                    if (window.Swiper) {
                        resolve(window.Swiper);
                    } else {
                        setTimeout(check, 100);
                    }
                };
                check();
            });
        }

        // Get recommendations using the newer API
        // https://www.algolia.com/doc/libraries/javascript/v5/methods/recommend/get-recommendations/?client=javascript
        console.log('📡 Fetching recommendations...');
        recommendClient.getRecommendations([
            {
                indexName: indexName,
                objectID: currentObjectID,
                model: 'related-products',
                threshold: 0,
                maxRecommendations: 10
            }
        ]).then(({ results }) => {
            console.log('📦 Raw results:', results);
            const recommendations = results[0].hits;
            console.log('🎯 Recommendations found:', recommendations.length, recommendations);
            
            // Remove spinner, prepare for populating with recommendations
            container.innerHTML = '';
            
            recommendations.forEach(item => {
                
                let product = algoliaShopify.assign({}, item, {
                    _distinct: false,
                    can_order:
                        item.inventory_management !== 'shopify' ||
                        item.Numberinventory_policy === 'continue' ||
                        item.inventory_quantity > 0,
                    translations: algoliaShopify.translations,
                    isOnSale: Number(item.compare_at_price) && Number(item.compare_at_price) > Number(item.price),
                    isNewIn: function () {
                        return this.collections && this.collections.find(collection => collection.toLowerCase().startsWith('new'));
                    },
                    queryID: item.__queryID,
                    productPosition: item.__position,
                    index: 'shopify_products',
                });

                let template = algoliaShopify.compileTemplate('instant_search_product');
                let element = algoliaShopify.render(template, product);
                let div = document.createElement('div');
                div.className = 'swiper-slide';
                div.innerHTML = element;
                container.appendChild(div);
            });

            // Initialize Swiper after recommendations are loaded
            console.log('🎠 Initializing Swiper with', recommendations.length, 'recommendations');
            if (recommendations.length) {
                // Wrap slides in swiper-wrapper
                const swiperWrapper = document.createElement('div');
                swiperWrapper.className = 'swiper-wrapper';
                
                // Move all slides into the wrapper
                while (container.firstChild) {
                    swiperWrapper.appendChild(container.firstChild);
                }
                container.appendChild(swiperWrapper);
                
                // Use the navigation buttons from the header
                const navButtons = document.getElementById('relatedNavButtons');
                const prevButton = document.getElementById('relatedNavPrev');
                const nextButton = document.getElementById('relatedNavNext');
                
                // Show the navigation buttons
                if (navButtons) {
                    navButtons.style.display = 'flex';
                }
                
                // Add swiper class to container
                container.classList.add('swiper');
                
                // Run dependency check and wait for images to load
                // Ensures Swiper is initialized at correct dimensions
                Promise.all([
                    waitForDependencies(),
                    ...Array.from(container.getElementsByTagName('img'))
                        .filter(img => !img.complete)
                        .map(img => new Promise(resolve => {
                            img.onload = img.onerror = resolve;
                        }))
                ]).then(([Swiper]) => {
                    
                    if (swiperInitialized) {
                        return;
                    }
                    
                    // Initialize Swiper instance
                    console.log('🎢 Creating Swiper instance...');
                    swiperInstance = new Swiper(container, {
                        slidesPerView: recommendations.length >= 4 ? 4 : recommendations.length,
                        slidesPerGroup: 1,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: nextButton,
                            prevEl: prevButton,
                        },
                        loop: false,
                        watchOverflow: true,
                        a11y: {
                            enabled: true,
                        },
                        breakpoints: {
                            0: {
                                slidesPerView: 2,
                                slidesPerGroup: 1,
                                spaceBetween: 15,
                            },
                            760: {
                                slidesPerView: 2,
                                slidesPerGroup: 1,
                                spaceBetween: 15,
                            },
                            900: {
                                slidesPerView: recommendations.length >= 4 ? 4 : recommendations.length,
                                slidesPerGroup: 1,
                                spaceBetween: 0,
                            }
                        }
                    });

                    swiperInitialized = true;
                    container.style.transition = 'opacity 0.3s ease';
                    container.style.opacity = '1';
                    container.classList.add('loaded');
                    console.log('✅ Swiper initialized successfully!');
                });
            } else {
                // Hide navigation buttons when no recommendations
                const navButtons = document.getElementById('relatedNavButtons');
                if (navButtons) {
                    navButtons.style.display = 'none';
                }
            }
        }).catch(error => {
            console.error('❌ Error getting recommendations:', error);
            // Errored, but remove spinner anyway to resolve UX
            container.innerHTML = '';
            // Hide navigation buttons on error
            const navButtons = document.getElementById('relatedNavButtons');
            if (navButtons) {
                navButtons.style.display = 'none';
            }
        });
        
        }).catch(error => {
            console.error('❌ Error loading Algolia Recommend:', error);
            container.innerHTML = '';
            // Hide navigation buttons on error
            const navButtons = document.getElementById('relatedNavButtons');
            if (navButtons) {
                navButtons.style.display = 'none';
            }
        });

        setTimeout(function () {
            function waitForHoverableImage(selector) {
                return new Promise(resolve => {
                    if (document.querySelector(selector)) {
                        return resolve(document.querySelectorAll(selector));
                    }

                    let observer = new MutationObserver(mutations => {
                        if (document.querySelector(selector)) {
                            resolve(document.querySelectorAll(selector));
                            observer.disconnect();
                        }
                    });

                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                });
            }

            let hoverableImagePromise = null;

            setInterval(function () {
                hoverableImagePromise = waitForHoverableImage('[data-hoverable-image]').then(function (elements) {
                    [...elements].filter(function (image) {
                        let secondImage = $(image).data('second-image');

                        return secondImage === '';
                    }).forEach(function (image) {
                        $.get('/products/' + $(image).data('hoverable-image') + '.json').then(function (response) {
                            if (response.product.images[1]) {
                                let imageSource = response.product.images[1].src.replace('.jpg', '_grande.jpg');
                                $(image).data('second-image', imageSource);
                                // Preload the image
                                $('<img />')[0].src = response.product.images[1].src.replace('.jpg', '_grande.jpg');
                            } else {
                                $(image).data('second-image', 'no-image');
                            }
                        });
                    });
                });
            }, 1000);
        }, 500);

        $('body').on('mouseenter', '[data-hoverable-image]', function () {
            let secondImage = $(this).data('second-image');

            if (!secondImage || secondImage === 'no-image') {
                return;
            }

            $(this).attr('src', $(this).data('second-image'));
        });

        $('body').on('mouseleave', '[data-hoverable-image]', function () {
            $(this).attr('src', $(this).data('original'));
        });

        if (typeof carouselObserver !== 'undefined') {
            carouselObserver.disconnect();
        }
    })(productId);
}
